import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

const fmtDate = d => { if (!d) return '-'; const dt = new Date(d + 'T00:00:00'); return dt.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }).replace(/ /g, ' ').replace(/^(\d+) (\w+) (\d+)$/, '$1 $2, $3'); };

export default function Readings() {
  const [readings, setReadings] = useState([]);
  const [barangays, setBarangays] = useState([]);
  const [filters, setFilters] = useState({ barangay_id: '', reading_date: '' });
  const [loading, setLoading] = useState(true);
  const [showSelect, setShowSelect] = useState(false);
  const [editId, setEditId] = useState(null);
  const [editData, setEditData] = useState({ reading_date: '', meter_reading: '' });
  const [saving, setSaving] = useState(false);
  const navigate = useNavigate();

  const load = () => {
    setLoading(true);
    const params = {};
    if (filters.barangay_id) params.barangay_id = filters.barangay_id;
    if (filters.reading_date) params.reading_date = filters.reading_date;
    api.get('/readings', { params }).then(r => { setReadings(r.data); setLoading(false); });
  };

  useEffect(() => { api.get('/barangays').then(r => setBarangays(r.data)); }, []);
  useEffect(load, [filters.barangay_id, filters.reading_date]); // eslint-disable-line

  const startEdit = (r) => {
    setEditId(r.id);
    setEditData({ reading_date: r.reading_date, meter_reading: String(r.meter_reading) });
  };

  const cancelEdit = () => {
    setEditId(null);
    setEditData({ reading_date: '', meter_reading: '' });
  };

  const saveEdit = async () => {
    if (!editData.reading_date || !editData.meter_reading) return;
    setSaving(true);
    try {
      await api.put(`/readings/${editId}`, {
        reading_date: editData.reading_date,
        meter_reading: parseInt(editData.meter_reading, 10),
      });
      setEditId(null);
      load();
    } catch (e) {
      alert(e.response?.data?.message || 'Failed to update reading');
    }
    setSaving(false);
  };

  const deleteReading = async (r) => {
    if (!window.confirm(`Delete reading for ${r.consumer_name} on ${fmtDate(r.reading_date)}?\n\nMeter reading: ${r.meter_reading}\n\nThis cannot be undone.`)) return;
    try {
      await api.delete(`/readings/${r.id}`);
      load();
    } catch (e) {
      alert(e.response?.data?.message || 'Failed to delete reading');
    }
  };

  return (
    <div>
      <div className="flex-between mb-16">
        <h1 className="page-title" style={{margin:0}}>Meter Readings</h1>
        <button className="btn btn-primary" onClick={() => setShowSelect(true)}>Batch Entry</button>
      </div>

      {showSelect && (
        <div className="card mb-16">
          <h3>Select Barangay for Batch Entry</h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))', gap: 8, marginTop: 12 }}>
            {barangays.map(b => (
              <button key={b.id} className="btn btn-primary" onClick={() => navigate(`/readings/batch/${b.id}`)}>{b.name}</button>
            ))}
          </div>
          <button className="btn" style={{ marginTop: 12, background: '#eee' }} onClick={() => setShowSelect(false)}>Cancel</button>
        </div>
      )}

      <div className="filters">
        <select className="input" style={{width:180}} value={filters.barangay_id} onChange={e => setFilters(f => ({...f, barangay_id: e.target.value}))}>
          <option value="">All Barangays</option>
          {barangays.map(b => <option key={b.id} value={b.id}>{b.name}</option>)}
        </select>
        <input className="input" type="date" style={{width:180}} value={filters.reading_date} onChange={e => setFilters(f => ({...f, reading_date: e.target.value}))} />
        {filters.reading_date && <button className="btn btn-sm" style={{background:'#eee'}} onClick={() => setFilters(f => ({...f, reading_date: ''}))}>Clear</button>}
      </div>

      {loading ? <div className="loading"><div className="spinner"></div></div> : (
        <div className="card table-wrap">
          <table>
            <thead><tr><th>Account</th><th>Consumer</th><th>Barangay</th><th>Date</th><th className="text-right">Reading</th><th style={{width:120, textAlign:'center'}}>Actions</th></tr></thead>
            <tbody>
              {readings.map(r => (
                editId === r.id ? (
                  <tr key={r.id} style={{background:'#fffbe6'}}>
                    <td>{r.account_code}</td>
                    <td>{r.consumer_name}</td>
                    <td>{r.barangay_name}</td>
                    <td><input type="date" className="input" style={{width:150, padding:'4px 6px', fontSize:13}} value={editData.reading_date} onChange={e => setEditData(d => ({...d, reading_date: e.target.value}))} /></td>
                    <td className="text-right"><input type="number" className="input" style={{width:100, padding:'4px 6px', fontSize:13, textAlign:'right'}} value={editData.meter_reading} onChange={e => setEditData(d => ({...d, meter_reading: e.target.value}))} min="0" /></td>
                    <td style={{textAlign:'center'}}>
                      <button className="btn btn-sm" style={{background:'#2e7d32',color:'#fff',marginRight:4,padding:'3px 10px',fontSize:12}} onClick={saveEdit} disabled={saving}>{saving ? '...' : 'Save'}</button>
                      <button className="btn btn-sm" style={{background:'#eee',padding:'3px 10px',fontSize:12}} onClick={cancelEdit}>Cancel</button>
                    </td>
                  </tr>
                ) : (
                  <tr key={r.id}>
                    <td>{r.account_code}</td>
                    <td>{r.consumer_name}</td>
                    <td>{r.barangay_name}</td>
                    <td>{fmtDate(r.reading_date)}</td>
                    <td className="text-right">{r.meter_reading}</td>
                    <td style={{textAlign:'center'}}>
                      <button className="btn btn-sm" style={{background:'#1976d2',color:'#fff',marginRight:4,padding:'3px 10px',fontSize:12}} onClick={() => startEdit(r)}>Edit</button>
                      <button className="btn btn-sm" style={{background:'#d32f2f',color:'#fff',padding:'3px 10px',fontSize:12}} onClick={() => deleteReading(r)}>Delete</button>
                    </td>
                  </tr>
                )
              ))}
            </tbody>
          </table>
          <div style={{color:'#666', fontSize:13, marginTop:8}}>{readings.length} readings</div>
        </div>
      )}
    </div>
  );
}
